module.exports = __webpack_public_path__ + "img/google-forms.png";